import fireb from '../firebase/fireBase'
import configureStore from '../store/configureStore'
const testing = process.env.NODE_ENV === 'development'


const findContent = (type, collection, where, search, callback) => {
    const query = fireb.functions().httpsCallable('dbQuery');

    query({
        type,
        collection,
        where,
        search
    }).then(result => {
        callback(result.data)
    })
}

const getUsers = async (appid) => {
    const users = fireb.functions().httpsCallable('usersList');

    return users({
        appid
    }).then(({ data: { usersList } }) => usersList)
        .catch(err => console.log('Lo cacheteo', err))

}

const appLoginLog = async (user) => {
    const logIn = fireb.functions().httpsCallable('appLogin')
    let stripeCustomerId

    await logIn({
        user: user,
        apptype: 'admin',
        testing,
        appid: null
    }).then(({ data }) => {
        // console.log('Si llega aqui? ', data)
        stripeCustomerId = data.stripeCustomerId
    })

    configureStore.dispatch({
        type: 'SET_STRIPE_CUSTOMER_ID',
        payload: {
            stripeCustomerId
        }
    })

    return 'ok'
}

const createUser = async (appid, udata) => {
    const createUser = fireb.functions().httpsCallable('createUser')
    let uid

    await createUser({
        appid,
        udata
    }).then(result => {
        uid = result
    })

    return uid
}

const importUsers = async (appid, users, profiles) => {
    const doImport = fireb.functions().httpsCallable('createUsersBatch')
    let result

    await doImport({
        appid,
        users,
        profiles
    }).then(res => { result = res })

    return result
}

const pnSend = async (appid, title, message, icon, link) => {

    const pnSend = fireb.functions().httpsCallable('pnSend')
    let res

    await pnSend({
        appid,
        title,
        message,
        icon,
        link
    }).then(result => {
        res = result
    })

    return res

}

const createSubscription = async (data) => {
    const doSubscription = fireb.functions().httpsCallable('createSubscription')

    const sububscription = await doSubscription(data)

    return sububscription
}

const getUserSubscriptions = async (customerId, testing) => {
    const getSubscription = fireb.functions().httpsCallable('getUserSubscriptions')

    const subscriptions = await getSubscription({ customerId, testing })

    return subscriptions
}

const cancelSubscription = async (subscriptionId, testing) => {
    const cancel = fireb.functions().httpsCallable('cancelSubscription')

    const cancelSub = await cancel({ subscriptionId, testing })

    return cancelSub
}

const generatePdf = async (html, path, filename) => {
    const generate = fireb.functions().httpsCallable('generatePdf')

    const generateRes = await generate({ html, path, filename })

    return generateRes
}

const createAppFromTemplate = async (template, owner, ownerId, plan) => {
    const create = fireb.functions().httpsCallable('createFromTemplate')

    const createRes = await create({ template, owner, ownerId, plan })

    return createRes
}

export {
    findContent,
    getUsers,
    appLoginLog,
    createUser,
    importUsers,
    pnSend,
    createSubscription,
    getUserSubscriptions,
    cancelSubscription,
    generatePdf,
    createAppFromTemplate
}